import { atom } from "jotai";

export const step = atom(1);
export const serviceStep = atom(0);
export const totalAmount = atom(0);
